class FacetFiltersForm extends HTMLElement{constructor(){super(),this.onActiveFilterClick=this.onActiveFilterClick.bind(this),this.debouncedOnSubmit=debounce(event=>{this.onSubmitHandler(event)},800),this.querySelector("form").addEventListener("input",this.debouncedOnSubmit.bind(this));const facetWrapper=this.querySelector("#FacetsWrapperDesktop");facetWrapper&&facetWrapper.addEventListener("keyup",onKeyUpEscape)}static setListeners(){const onHistoryChange=event=>{const searchParams=event.state?event.state.searchParams:FacetFiltersForm.searchParamsInitial;searchParams!==FacetFiltersForm.searchParamsPrev&&FacetFiltersForm.renderPage(searchParams,null,!1)};window.addEventListener("popstate",onHistoryChange)}static toggleActiveFacets(disable=!0){document.querySelectorAll(".js-facet-remove").forEach(element=>{element.classList.toggle("disabled",disable)})}static renderPage(searchParams,event,updateURLHash=!0){FacetFiltersForm.searchParamsPrev=searchParams;const sections=FacetFiltersForm.getSections(),countContainer=document.getElementById("ProductCount"),countContainerDesktop=document.getElementById("ProductCountDesktop");document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach(spinner=>spinner.classList.remove("hidden")),document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading"),countContainer&&countContainer.classList.add("loading"),countContainerDesktop&&countContainerDesktop.classList.add("loading"),sections.forEach(section=>{const url=`${window.location.pathname}?section_id=${section.section}&${searchParams}`,filterDataUrl=element=>element.url===url;FacetFiltersForm.filterData.some(filterDataUrl)?FacetFiltersForm.renderSectionFromCache(filterDataUrl,event):FacetFiltersForm.renderSectionFromFetch(url,event)}),updateURLHash&&FacetFiltersForm.updateURLHash(searchParams)}static renderSectionFromFetch(url,event){fetch(url).then(response=>response.text()).then(responseText=>{const html=responseText;FacetFiltersForm.filterData=[...FacetFiltersForm.filterData,{html,url}],FacetFiltersForm.renderFilters(html,event),FacetFiltersForm.renderProductGridContainer(html),FacetFiltersForm.renderProductCount(html),typeof initializeScrollAnimationTrigger=="function"&&initializeScrollAnimationTrigger(html.innerHTML)})}static renderSectionFromCache(filterDataUrl,event){const html=FacetFiltersForm.filterData.find(filterDataUrl).html;FacetFiltersForm.renderFilters(html,event),FacetFiltersForm.renderProductGridContainer(html),FacetFiltersForm.renderProductCount(html),typeof initializeScrollAnimationTrigger=="function"&&initializeScrollAnimationTrigger(html.innerHTML)}static renderProductGridContainer(html){document.getElementById("ProductGridContainer").innerHTML=new DOMParser().parseFromString(html,"text/html").getElementById("ProductGridContainer").innerHTML,document.getElementById("ProductGridContainer").querySelectorAll(".scroll-trigger").forEach(element=>{element.classList.add("scroll-trigger--cancel")})}static renderProductCount(html){const count=new DOMParser().parseFromString(html,"text/html").getElementById("ProductCount").innerHTML,container=document.getElementById("ProductCount"),containerDesktop=document.getElementById("ProductCountDesktop");container.innerHTML=count,container.classList.remove("loading"),containerDesktop&&(containerDesktop.innerHTML=count,containerDesktop.classList.remove("loading")),document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach(spinner=>spinner.classList.add("hidden"))}static renderFilters(html,event){const parsedHTML=new DOMParser().parseFromString(html,"text/html"),facetDetailsElementsFromFetch=parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"),facetDetailsElementsFromDom=document.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter");Array.from(facetDetailsElementsFromDom).forEach(currentElement=>{Array.from(facetDetailsElementsFromFetch).some(({id})=>currentElement.id===id)||currentElement.remove()});const matchesId=element=>{const jsFilter=event?event.target.closest(".js-filter"):void 0;return jsFilter?element.id===jsFilter.id:!1},facetsToRender=Array.from(facetDetailsElementsFromFetch).filter(element=>!matchesId(element)),countsToRender=Array.from(facetDetailsElementsFromFetch).find(matchesId);if(facetsToRender.forEach((elementToRender,index)=>{if(document.getElementById(elementToRender.id))document.getElementById(elementToRender.id).innerHTML=elementToRender.innerHTML;else{if(index>0){const{className:previousElementClassName,id:previousElementId}=facetsToRender[index-1];if(elementToRender.className===previousElementClassName){document.getElementById(previousElementId).after(elementToRender);return}}elementToRender.parentElement&&document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender)}}),FacetFiltersForm.renderActiveFacets(parsedHTML),FacetFiltersForm.renderAdditionalElements(parsedHTML),countsToRender){const closestJSFilterID=event.target.closest(".js-filter").id;if(closestJSFilterID){FacetFiltersForm.renderCounts(countsToRender,event.target.closest(".js-filter")),FacetFiltersForm.renderMobileCounts(countsToRender,document.getElementById(closestJSFilterID));const newFacetDetailsElement=document.getElementById(closestJSFilterID),newElementSelector=newFacetDetailsElement.classList.contains("mobile-facets__details")?".mobile-facets__close-button":".facets__summary",newElementToActivate=newFacetDetailsElement.querySelector(newElementSelector),isTextInput=event.target.getAttribute("type")==="text";newElementToActivate&&!isTextInput&&newElementToActivate.focus()}}}static renderActiveFacets(html){[".active-facets-mobile",".active-facets-desktop"].forEach(selector=>{const activeFacetsElement=html.querySelector(selector);activeFacetsElement&&(document.querySelector(selector).innerHTML=activeFacetsElement.innerHTML)}),FacetFiltersForm.toggleActiveFacets(!1)}static renderAdditionalElements(html){[".mobile-facets__open",".mobile-facets__count",".sorting"].forEach(selector=>{html.querySelector(selector)&&(document.querySelector(selector).innerHTML=html.querySelector(selector).innerHTML)}),document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents()}static renderCounts(source,target){const targetSummary=target.querySelector(".facets__summary"),sourceSummary=source.querySelector(".facets__summary");sourceSummary&&targetSummary&&(targetSummary.outerHTML=sourceSummary.outerHTML);const targetHeaderElement=target.querySelector(".facets__header"),sourceHeaderElement=source.querySelector(".facets__header");sourceHeaderElement&&targetHeaderElement&&(targetHeaderElement.outerHTML=sourceHeaderElement.outerHTML);const targetWrapElement=target.querySelector(".facets-wrap"),sourceWrapElement=source.querySelector(".facets-wrap");sourceWrapElement&&targetWrapElement&&(target.querySelector("show-more-button .label-show-more.hidden")&&sourceWrapElement.querySelectorAll(".facets__item.hidden").forEach(hiddenItem=>hiddenItem.classList.replace("hidden","show-more-item")),targetWrapElement.outerHTML=sourceWrapElement.outerHTML)}static renderMobileCounts(source,target){const targetFacetsList=target.querySelector(".mobile-facets__list"),sourceFacetsList=source.querySelector(".mobile-facets__list");sourceFacetsList&&targetFacetsList&&(targetFacetsList.outerHTML=sourceFacetsList.outerHTML)}static updateURLHash(searchParams){history.pushState({searchParams},"",`${window.location.pathname}${searchParams&&"?".concat(searchParams)}`)}static getSections(){return[{section:document.getElementById("product-grid").dataset.id}]}createSearchParams(form){const formData=new FormData(form);return new URLSearchParams(formData).toString()}onSubmitForm(searchParams,event){FacetFiltersForm.renderPage(searchParams,event)}onSubmitHandler(event){event.preventDefault();const sortFilterForms=document.querySelectorAll("facet-filters-form form");if(event.srcElement.className=="mobile-facets__checkbox"){const searchParams=this.createSearchParams(event.target.closest("form"));this.onSubmitForm(searchParams,event)}else{const forms=[],isMobile=event.target.closest("form").id==="FacetFiltersFormMobile";sortFilterForms.forEach(form=>{isMobile?form.id==="FacetFiltersFormMobile"&&forms.push(this.createSearchParams(form)):(form.id==="FacetSortForm"||form.id==="FacetFiltersForm"||form.id==="FacetSortDrawerForm")&&forms.push(this.createSearchParams(form))}),this.onSubmitForm(forms.join("&"),event)}}onActiveFilterClick(event){event.preventDefault(),FacetFiltersForm.toggleActiveFacets();const url=event.currentTarget.href.indexOf("?")==-1?"":event.currentTarget.href.slice(event.currentTarget.href.indexOf("?")+1);FacetFiltersForm.renderPage(url)}}FacetFiltersForm.filterData=[],FacetFiltersForm.searchParamsInitial=window.location.search.slice(1),FacetFiltersForm.searchParamsPrev=window.location.search.slice(1),customElements.define("facet-filters-form",FacetFiltersForm),FacetFiltersForm.setListeners();class PriceRange extends HTMLElement{constructor(){super(),this.querySelectorAll("input").forEach(element=>{element.addEventListener("change",this.onRangeChange.bind(this)),element.addEventListener("keydown",this.onKeyDown.bind(this))}),this.setMinAndMaxValues()}onRangeChange(event){this.adjustToValidValues(event.currentTarget),this.setMinAndMaxValues()}onKeyDown(event){if(event.metaKey)return;const pattern=/[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;event.key.match(pattern)||event.preventDefault()}setMinAndMaxValues(){const inputs=this.querySelectorAll("input"),minInput=inputs[0],maxInput=inputs[1];maxInput.value&&minInput.setAttribute("data-max",maxInput.value),minInput.value&&maxInput.setAttribute("data-min",minInput.value),minInput.value===""&&maxInput.setAttribute("data-min",0),maxInput.value===""&&minInput.setAttribute("data-max",maxInput.getAttribute("data-max"))}adjustToValidValues(input){const value=Number(input.value),min=Number(input.getAttribute("data-min")),max=Number(input.getAttribute("data-max"));value<min&&(input.value=min),value>max&&(input.value=max)}}customElements.define("price-range",PriceRange);class FacetRemove extends HTMLElement{constructor(){super();const facetLink=this.querySelector("a");facetLink.setAttribute("role","button"),facetLink.addEventListener("click",this.closeFilter.bind(this)),facetLink.addEventListener("keyup",event=>{event.preventDefault(),event.code.toUpperCase()==="SPACE"&&this.closeFilter(event)})}closeFilter(event){event.preventDefault(),(this.closest("facet-filters-form")||document.querySelector("facet-filters-form")).onActiveFilterClick(event)}}customElements.define("facet-remove",FacetRemove);
//# sourceMappingURL=/cdn/shop/t/7/assets/facets.js.map?v=42798985796066624181782211032

/* Avian approved collection mobile + desktop overlay - 2026-07-29 */
(function () {
  if (!document.body.classList.contains('collection')) return;
  if (window.__avianApprovedCollectionOverlay20260729) return;
  window.__avianApprovedCollectionOverlay20260729 = true;

  var mqDesktop = window.matchMedia('(min-width: 750px)');
  var state = { cue: '', sort: '' };
  var originalIndexSet = false;
  var scrollState = { observer: null, busy: false, nextPage: 0 };
  var restoreState = { pendingY: null, didRestore: false };

  function collectionStorageKey() {
    var params = new URLSearchParams(location.search);
    params.delete('page');
    Array.from(params.keys()).forEach(function (key) {
      if (key.indexOf('_codex') === 0) params.delete(key);
    });
    return 'avianCollectionGridState:' + location.pathname + '?' + params.toString();
  }

  function saveListingState() {
    try {
      var grid = document.getElementById('product-grid') || productGrid();
      if (!grid) return;
      var pager = document.querySelector('#ProductGridContainer .pagination-wrapper, .pagination-wrapper');
      var payload = {
        html: grid.innerHTML,
        pagerHTML: pager ? pager.outerHTML : '',
        y: window.scrollY || 0,
        nextPage: scrollState.nextPage || (pageFromUrl(location.href) + 1),
        cue: state.cue || '',
        sort: state.sort || '',
        t: Date.now()
      };
      if (window.history && history.replaceState) {
        var currentState = history.state && typeof history.state === 'object' ? history.state : {};
        history.replaceState(Object.assign({}, currentState, { avianGridState: payload }), '', location.href);
      }
      if (window.sessionStorage) {
        sessionStorage.setItem(collectionStorageKey(), JSON.stringify(payload));
      }
    } catch (error) {}
  }

  function restoreListingState() {
    try {
      var saved = history.state && history.state.avianGridState ? history.state.avianGridState : null;
      if (!saved && window.sessionStorage) {
        var raw = sessionStorage.getItem(collectionStorageKey());
        if (raw) saved = JSON.parse(raw);
      }
      if (!saved) return false;
      if (!saved || !saved.html || Date.now() - saved.t > 30 * 60 * 1000) return false;
      var grid = document.getElementById('product-grid') || productGrid();
      if (!grid) return false;
      var holder = document.createElement('div');
      holder.innerHTML = saved.html;
      if (holder.children.length <= grid.children.length) {
        restoreState.pendingY = Number(saved.y || 0);
        return false;
      }
      grid.innerHTML = saved.html;
      var existingPager = document.querySelector('#ProductGridContainer .pagination-wrapper, .pagination-wrapper');
      if (saved.pagerHTML) {
        if (existingPager) existingPager.outerHTML = saved.pagerHTML;
        else grid.insertAdjacentHTML('afterend', saved.pagerHTML);
      } else if (existingPager) {
        existingPager.remove();
      }
      scrollState.nextPage = Number(saved.nextPage || 0) || 0;
      state.cue = saved.cue || state.cue || '';
      state.sort = saved.sort || state.sort || '';
      restoreState.pendingY = Number(saved.y || 0);
      restoreState.didRestore = true;
      return true;
    } catch (error) {
      return false;
    }
  }

  function restoreScrollPosition() {
    if (restoreState.pendingY === null) return;
    var y = restoreState.pendingY;
    restoreState.pendingY = null;
    setTimeout(function () { window.scrollTo(0, y); }, 40);
    setTimeout(function () { window.scrollTo(0, y); }, 260);
  }

  var COLLECTIONS = {
    sofas: {
      eyebrow: 'Luxury sofas',
      title: 'Premium Sofas',
      cueTitle: ['The Sofa', 'Edit'],
      summary: 'A refined edit of recliner, sofa-cum-bed and curved sofas for modern living rooms, villas and family lounges.',
      filters: [
        { label: 'Recliner', words: ['recliner', 'motorised', 'motorized', 'mellow', 'apex'] },
        { label: 'Sofa Cum Bed', words: ['sofa cum bed', 'sofa-cum-bed', 'sofa bed', 'sleeper', 'storage', 'paloma'] },
        { label: 'Curved', words: ['curved', 'curve', 'opal', 'crescent', 'round'] }
      ]
    },
    beds: {
      eyebrow: 'Luxury beds',
      title: 'Premium Beds',
      cueTitle: ['The Bed', 'Edit'],
      summary: 'Leather, upholstered and statement beds selected for calm bedrooms, master suites and refined apartments.',
      filters: [
        { label: 'Leather', words: ['leather', 'hide', 'pu', 'faux leather', 'silas', 'siena', 'aura', 'alba'] },
        { label: 'Upholstered', words: ['fabric', 'upholstered', 'linen', 'velvet', 'boucle', 'cloth', 'bedstead', 'lova'] },
        { label: 'Statement', words: ['statement', 'monarch', 'bronze', 'valenza', 'basel', 'marsana', 'lumina', 'icon', 'atlantis', 'aqua', 'capella', 'marquesa', 'hortense', 'prescott'] }
      ]
    },
    'dining-table': {
      eyebrow: 'Dining rooms',
      title: 'Dining Tables',
      cueTitle: ['The Dining', 'Edit'],
      summary: 'Marble, round, extendable and statement dining tables for formal dining rooms, apartments and villas.',
      filters: [
        { label: 'Marble / Stone', words: ['marble', 'stone', 'ceramic', 'travertine', 'onyx', 'sintered'] },
        { label: 'Round / Extendable', words: ['round', 'extendable', 'extension', 'oval', 'circular'] },
        { label: 'Statement Pedestal', words: ['pedestal', 'statement', 'foyer', 'juno', 'red foyer', 'aurelia', 'vesper', 'aethel', 'elysian', 'koa', 'esther', 'nagoya', 'hera', 'legato', 'truva', 'time', 'silver', 'capella'] }
      ]
    },
    'dining-chair': {
      eyebrow: 'Dining rooms',
      title: 'Dining Chairs',
      cueTitle: ['Dining Chair', 'Edit'],
      summary: 'Comfortable dining chairs and statement seating chosen to complete premium dining spaces.',
      filters: [
        { label: 'Arm Chairs', words: ['armchair', 'arm chair', 'arms', 'with arm', 'buggati', 'versace arm', 'manila armchair'] },
        { label: 'Statement Chairs', words: ['versace', 'buggati', 'hermes', 'turri', 'imperial', 'honour', 'monte carlo', 'santiago', 'aston', 'benz', 'slique'] },
        { label: 'Classic Chairs', words: ['noble', 'paris', 'quilt', 'stella', 'judy', 'calora', 'rosa', 'charlotte', 'capella', 'riga', 'legato', 'lucid', 'cielo'] }
      ]
    },
    'coffee-tables': {
      eyebrow: 'Living room accents',
      title: 'Coffee Tables',
      cueTitle: ['Coffee Table', 'Edit'],
      summary: 'Sculptural, nesting and statement coffee tables chosen to anchor sofas, lounges and conversation spaces.',
      filters: [
        { label: 'Table Sets', words: ['set', 'nesting', 'nested', 'pair', 'combo', 'duo', 'trio'] },
        { label: 'Round / Organic', words: ['round', 'curved', 'curve', 'oval', 'circle', 'organic', 'pebble', 'clover', 'cusp', 'eclipse'] },
        { label: 'Marble / Stone', words: ['marble', 'stone', 'travertine', 'onyx', 'ceramic', 'slab', 'block', 'pietra', 'moda dark'] }
      ]
    },
    'side-tables': {
      eyebrow: 'Living room accents',
      title: 'Side Tables',
      cueTitle: ['Side Table', 'Edit'],
      summary: 'Compact accent tables, sculptural side pieces and refined surfaces for lounges and bedrooms.',
      filters: [
        { label: 'C Tables', words: ['c table', 'c-table', 'c side', 'circular', 'c8149', 'c8037', 'cc1088', 'f510', '034'] },
        { label: 'Sets / Nesting', words: ['nesting', 'nested', 'set', 'pair', 'trio', 'azure trio', 'framework trio', 'art coffee table'] },
        { label: 'Sculptural', words: ['aureo', 'vittoria', 'celeste', 'vertex', 'helios', 'nikos', 'soren', 'lyra', 'kreta', 'luna', 'vane', 'duck', 'twist', 'mono', 'prisma', 'pietra'] }
      ]
    },
    consoles: {
      eyebrow: 'Statement surfaces',
      title: 'Consoles',
      cueTitle: ['Console', 'Edit'],
      summary: 'Design-led consoles for entryways, living rooms, corridors and styled interior moments.',
      filters: [
        { label: 'Storage', words: ['storage', 'drawer', 'cabinet', 'sideboard', 'credenza', 'buffet', 'door', 'shelf', 'unit'] },
        { label: 'Display', words: ['display', 'shelf', 'open', 'console table', 'console'] },
        { label: 'Statement', words: ['statement', 'sculptural', 'curved', 'marble', 'travertine', 'brass', 'contour', 'ridge', 'z console'] }
      ]
    },
    bergers: {
      eyebrow: 'Accent seating',
      title: 'Armchairs & Bergers',
      cueTitle: ['Accent Chair', 'Edit'],
      summary: 'Accent chairs and bergers that add comfort, character and a finished mood to living spaces.',
      filters: [
        { label: 'Swivel', words: ['swivel', 'revolving', 'rotating'] },
        { label: 'Lounge Chair', words: ['lounge', 'lounger', 'relax', 'accent', 'berger'] },
        { label: 'Leather', words: ['leather', 'hide', 'pu', 'manchester', 'california', 'solana', 'vanguard', 'gatsby'] }
      ]
    },
    pouffes: {
      eyebrow: 'Soft accents',
      title: 'Pouffes',
      cueTitle: ['Pouffe', 'Edit'],
      summary: 'Pouffes and ottomans for flexible seating, layered lounges and finished living rooms.',
      filters: [
        { label: 'Ottoman', words: ['ottoman', 'stool', 'bench'] },
        { label: 'Round / Hoop', words: ['round', 'circular', 'circle', 'hoop', 'orbit'] },
        { label: 'Soft Accent', words: ['soft', 'fabric', 'boucle', 'velvet', 'pouffe', 'daisy', 'sirocco', 'kanso'] }
      ]
    },
    'bar-counter': {
      eyebrow: 'Home bar edits',
      title: 'Bar Counters',
      cueTitle: ['Home Bar', 'Edit'],
      summary: 'Statement bar counters and home bar furniture for entertaining zones, farmhouses and luxury residences.',
      filters: [
        { label: 'Bar Cabinet', words: ['cabinet', 'storage', 'shelf', 'drawer', 'unit', 'montclair', 'hudson'] },
        { label: 'Leather Bar', words: ['leather', 'astor', 'mercer', 'hampton', 'cavallo', 'aurelius'] },
        { label: 'Portable / Trolley', words: ['portable', 'trolley', 'trunk', 'standing', 'counter', 'superstar', 'loite'] }
      ]
    },
    'bar-stools': {
      eyebrow: 'Bar seating',
      title: 'Bar Stools',
      cueTitle: ['Bar Stool', 'Edit'],
      summary: 'Counter-height and bar-height seating selected for home bars, kitchen islands and entertainment spaces.',
      filters: [
        { label: 'Bar Stools', words: ['bar stool', 'barstool', 'stool', 'flecia', 'chaplin', 'mila'] },
        { label: 'Bar Chairs', words: ['chair', 'charla', 'crown', 'bowl', 'chardonay', 'olivia'] },
        { label: 'Statement Seating', words: ['vera', 'elara', 'betsy', 'rose', 'chaplin', 'crown', 'bowl'] }
      ]
    },
    'outdoor-sofa': {
      eyebrow: 'Outdoor living',
      title: 'Outdoor Sofas',
      cueTitle: ['Outdoor Sofa', 'Edit'],
      summary: 'Outdoor sofas, loungers and relaxed seating selected for terraces, gardens, pool decks and farmhouses.',
      filters: [
        { label: 'Lounge Set', words: ['lounge', 'set', 'sofa set', 'seater'] },
        { label: 'L-Shape / Corner', words: ['l shape', 'l-shape', 'corner', 'sectional', 'chaise'] },
        { label: 'Rattan / Aluminium', words: ['rattan', 'rope', 'wicker', 'aluminium', 'aluminum', 'metal'] }
      ]
    },
    'office-desks': {
      eyebrow: 'Workspaces',
      title: 'Office Desks',
      cueTitle: ['Workspace', 'Edit'],
      summary: 'Executive desks and workspace furniture for home offices, studies and premium work settings.',
      filters: [
        { label: 'Executive', words: ['executive', 'director', 'manager'] },
        { label: 'MD / Director', words: ['md desk', 'director', 'regent', 'morrow', 'axis', 'modena'] },
        { label: 'Desk Tables', words: ['desk', 'table', 'suite', 'aristo', 'lucent', 'verona', 'eclipse', 'arista', 'nova', 'helix', 'aureon', 'astra'] }
      ]
    },
    bookcase: {
      eyebrow: 'Storage & display',
      title: 'Bookcases',
      cueTitle: ['Bookcase', 'Edit'],
      summary: 'Bookcases and display storage for studies, lounges and thoughtfully layered interiors.',
      filters: [
        { label: 'Bookcases', words: ['bookcase', 'cante', 'hampton', 'paloma', 'blend'] },
        { label: 'Showcase', words: ['showcase', 'display', 'arcadia'] },
        { label: 'Display Storage', words: ['storage', 'display', 'bookcase', 'showcase', 'paloma', 'blend', 'hampton'] }
      ]
    },
    cushions: {
      eyebrow: 'Decor accents',
      title: 'Cushions',
      cueTitle: ['Cushion', 'Edit'],
      summary: 'Cushions and soft accents that finish sofas, beds and lounge settings with texture and colour.',
      filters: [
        { label: 'Lumbar Cushions', words: ['lumbar', 'cushion', 'pillow'] },
        { label: 'Sets of 2', words: ['set of 2', 'duo', 'trio', 'set'] },
        { label: 'Velvet / Texture', words: ['velvet', 'texture', 'textured', 'embroidered', 'woven', 'jacquard', 'waffle', 'fur', 'fringe', 'shag', 'feathered'] }
      ]
    },
    painting: {
      eyebrow: 'Wall art',
      title: 'Painting/Artwork',
      cueTitle: ['Art', 'Edit'],
      summary: 'Paintings and artworks selected to add colour, scale and a finished gallery mood to modern homes.',
      filters: [
        { label: 'Abstract Art', words: ['abstract', 'canvas', 'artwork', 'painting'] },
        { label: 'Warm Tones', words: ['terracotta', 'rust', 'orange', 'gold', 'warm'] },
        { label: 'Statement Scale', words: ['large', 'oversized', 'statement', 'wall'] }
      ]
    },
    'sofa-beds': {
      eyebrow: 'Flexible living',
      title: 'Sofa Beds',
      cueTitle: ['Sleeper Sofa', 'Edit'],
      summary: 'Sofa beds and sleeper sofas selected for guest rooms, lounges and compact luxury homes.',
      filters: [
        { label: 'Sleeper Sofas', words: ['sleeper', 'sofa bed', 'sofa-bed', 'sofa cum bed', 'sofa-cum-bed'] },
        { label: 'Storage', words: ['storage', 'drawer', 'box', 'paloma'] },
        { label: 'Comfort First', words: ['soft', 'comfort', 'lounge', 'cushion'] }
      ]
    },
    trolley: {
      eyebrow: 'Serving accents',
      title: 'Trolleys',
      cueTitle: ['Trolley', 'Edit'],
      summary: 'Serving trolleys and mobile accents for dining rooms, bars and entertaining corners.',
      filters: [
        { label: 'Bar Trolley', words: ['bar', 'wine', 'drink', 'cocktail'] },
        { label: 'Serving Trolley', words: ['serving', 'serve', 'tea', 'trolley'] },
        { label: 'Statement Accent', words: ['gold', 'brass', 'metal', 'glass', 'statement'] }
      ]
    },
    'shoe-racks': {
      eyebrow: 'Entryway storage',
      title: 'Shoe Racks',
      cueTitle: ['Entry Storage', 'Edit'],
      summary: 'Shoe racks and entry storage pieces selected for cleaner foyers and organised everyday living.',
      filters: [
        { label: 'Closed Storage', words: ['closed', 'cabinet', 'door', 'drawer'] },
        { label: 'Bench Style', words: ['bench', 'seat', 'seating'] },
        { label: 'Compact', words: ['compact', 'slim', 'narrow', 'shoe'] }
      ]
    },
    'bed-ends': {
      eyebrow: 'Bedroom accents',
      title: 'Bed Ends',
      cueTitle: ['Bedroom Bench', 'Edit'],
      summary: 'Bed-end benches and bedroom accents selected to complete master suites with softness and function.',
      filters: [
        { label: 'Benches', words: ['bench', 'bed end', 'bed-end'] },
        { label: 'Upholstered', words: ['fabric', 'velvet', 'boucle', 'upholstered', 'soft'] },
        { label: 'Storage', words: ['storage', 'drawer', 'box'] }
      ]
    },
    dresser: {
      eyebrow: 'Bedroom storage',
      title: 'Dressers',
      cueTitle: ['Dresser', 'Edit'],
      summary: 'Dressers, vanity units and storage pieces for refined bedrooms and dressing corners.',
      filters: [
        { label: 'Vanity Units', words: ['vanity', 'dressing', 'mirror'] },
        { label: 'Storage', words: ['drawer', 'storage', 'cabinet'] },
        { label: 'Bedroom Accent', words: ['dresser', 'bedroom', 'console'] }
      ]
    },
    'bedroom-chairs': {
      eyebrow: 'Bedroom seating',
      title: 'Bedroom Chairs',
      cueTitle: ['Bedroom Chair', 'Edit'],
      summary: 'Bedroom chairs and soft seating for reading corners, dressing areas and calm private spaces.',
      filters: [
        { label: 'Accent Chairs', words: ['accent', 'chair', 'berger'] },
        { label: 'Lounge Chairs', words: ['lounge', 'relax', 'soft'] },
        { label: 'Compact Seating', words: ['compact', 'small', 'corner'] }
      ]
    },
    'tv-unit': {
      eyebrow: 'Media storage',
      title: 'TV Units',
      cueTitle: ['Media Unit', 'Edit'],
      summary: 'TV units and media storage selected for living rooms, bedrooms and entertainment walls.',
      filters: [
        { label: 'Storage Units', words: ['storage', 'drawer', 'cabinet', 'unit'] },
        { label: 'Console Style', words: ['console', 'low', 'media'] },
        { label: 'Wall Units', words: ['wall', 'panel', 'tv'] }
      ]
    },
    'buffet-cabinet': {
      eyebrow: 'Dining storage',
      title: 'Buffet Cabinets',
      cueTitle: ['Buffet', 'Edit'],
      summary: 'Buffet cabinets and dining storage pieces selected for serving, display and refined dining rooms.',
      filters: [
        { label: 'Buffet Storage', words: ['buffet', 'sideboard', 'storage'] },
        { label: 'Display Cabinet', words: ['display', 'glass', 'shelf'] },
        { label: 'Console Style', words: ['console', 'cabinet', 'credenza'] }
      ]
    },
    'office-chairs': {
      eyebrow: 'Work seating',
      title: 'Office Chairs',
      cueTitle: ['Office Chair', 'Edit'],
      summary: 'Office chairs selected for executive cabins, studies, workstations and home offices.',
      filters: [
        { label: 'Executive Chairs', words: ['executive', 'director', 'manager', 'high back'] },
        { label: 'Visitor Chairs', words: ['visitor', 'guest', 'meeting'] },
        { label: 'Ergonomic', words: ['ergonomic', 'mesh', 'adjustable', 'swivel'] }
      ]
    },
    'writing-desk': {
      eyebrow: 'Study corners',
      title: 'Writing Desks',
      cueTitle: ['Writing Desk', 'Edit'],
      summary: 'Writing desks and compact study tables selected for bedrooms, studies and focused work corners.',
      filters: [
        { label: 'Writing Desks', words: ['writing', 'desk'] },
        { label: 'Compact', words: ['compact', 'small', 'slim'] },
        { label: 'Storage', words: ['drawer', 'storage', 'shelf'] }
      ]
    },
    'conference-tables': {
      eyebrow: 'Meeting rooms',
      title: 'Conference Tables',
      cueTitle: ['Meeting Table', 'Edit'],
      summary: 'Conference tables and meeting tables selected for offices, boardrooms and collaborative workspaces.',
      filters: [
        { label: 'Conference', words: ['conference', 'meeting', 'boardroom'] },
        { label: 'Office Tables', words: ['office', 'table', 'desk'] },
        { label: 'Large Format', words: ['large', 'long', 'multi'] }
      ]
    },
    'co-working-tables': {
      eyebrow: 'Shared workspaces',
      title: 'Co-Working Tables',
      cueTitle: ['Co-Working', 'Edit'],
      summary: 'Co-working tables and shared workspace furniture for collaborative offices and flexible work zones.',
      filters: [
        { label: 'Shared Tables', words: ['co-working', 'coworking', 'shared'] },
        { label: 'Modular', words: ['modular', 'flexible', 'multi'] },
        { label: 'Office Tables', words: ['office', 'table', 'desk'] }
      ]
    },
    'bar-cabinet': {
      eyebrow: 'Home bar storage',
      title: 'Bar Cabinets',
      cueTitle: ['Bar Cabinet', 'Edit'],
      summary: 'Bar cabinets and storage-led home bar pieces for entertaining rooms, lounges and farmhouses.',
      filters: [
        { label: 'Storage Cabinets', words: ['cabinet', 'storage', 'drawer', 'door'] },
        { label: 'Wine Storage', words: ['wine', 'bottle', 'rack'] },
        { label: 'Statement Bar', words: ['bar', 'statement', 'leather', 'brass'] }
      ]
    },
    'bar-back-counter': {
      eyebrow: 'Home bar display',
      title: 'Bar Back Counters',
      cueTitle: ['Back Bar', 'Edit'],
      summary: 'Back counters and bar display storage selected to complete home bar and entertainment setups.',
      filters: [
        { label: 'Back Counter', words: ['back counter', 'back bar', 'counter'] },
        { label: 'Display', words: ['display', 'shelf', 'glass'] },
        { label: 'Storage', words: ['storage', 'cabinet', 'drawer'] }
      ]
    },
    chair: {
      eyebrow: 'Outdoor seating',
      title: 'Outdoor Chairs',
      cueTitle: ['Outdoor Chair', 'Edit'],
      summary: 'Outdoor chairs selected for terraces, gardens, balconies and poolside seating.',
      filters: [
        { label: 'Lounge Chairs', words: ['lounge', 'relax', 'armchair'] },
        { label: 'Dining Chairs', words: ['dining', 'chair'] },
        { label: 'Outdoor Material', words: ['outdoor', 'rattan', 'rope', 'wicker', 'aluminium', 'metal'] }
      ]
    },
    'outdoor-table': {
      eyebrow: 'Outdoor tables',
      title: 'Outdoor Tables',
      cueTitle: ['Outdoor Table', 'Edit'],
      summary: 'Outdoor tables selected for terraces, gardens, pool decks and open-air dining spaces.',
      filters: [
        { label: 'Dining Tables', words: ['dining', 'dinner'] },
        { label: 'Coffee Tables', words: ['coffee', 'centre', 'center'] },
        { label: 'Side Tables', words: ['side', 'accent'] }
      ]
    },
    'outdoor-swing': {
      eyebrow: 'Outdoor leisure',
      title: 'Outdoor Swings',
      cueTitle: ['Outdoor Swing', 'Edit'],
      summary: 'Outdoor swings and relaxed seating pieces for gardens, balconies, terraces and farmhouses.',
      filters: [
        { label: 'Swings', words: ['swing', 'hanging'] },
        { label: 'Lounge', words: ['lounge', 'relax', 'daybed'] },
        { label: 'Outdoor Material', words: ['outdoor', 'rope', 'rattan', 'wicker', 'metal'] }
      ]
    },
    lounger: {
      eyebrow: 'Outdoor lounging',
      title: 'Loungers',
      cueTitle: ['Lounger', 'Edit'],
      summary: 'Loungers and sunbeds selected for pool decks, terraces, gardens and resort-style outdoor spaces.',
      filters: [
        { label: 'Sunbeds', words: ['sunbed', 'sun bed', 'daybed'] },
        { label: 'Loungers', words: ['lounger', 'lounge'] },
        { label: 'Poolside', words: ['pool', 'outdoor', 'terrace'] }
      ]
    },
    carpets: {
      eyebrow: 'Floor accents',
      title: 'Carpets',
      cueTitle: ['Carpet', 'Edit'],
      summary: 'Carpets and rugs selected to add warmth, texture and softness to living rooms, bedrooms and lounges.',
      filters: [
        { label: 'Rugs', words: ['rug', 'carpet'] },
        { label: 'Textured', words: ['texture', 'textured', 'woven', 'tufted'] },
        { label: 'Large Format', words: ['large', 'oversized', 'big'] }
      ]
    },
    accesories: {
      eyebrow: 'Decor objects',
      title: 'Accessories',
      cueTitle: ['Decor', 'Edit'],
      summary: 'Decor accessories and objects selected to finish shelves, consoles, coffee tables and styled corners.',
      filters: [
        { label: 'Decor Objects', words: ['decor', 'object', 'sculpture'] },
        { label: 'Vases', words: ['vase', 'jar', 'pot'] },
        { label: 'Tabletop', words: ['tabletop', 'tray', 'bowl'] }
      ]
    },
    accessories: {
      eyebrow: 'Decor objects',
      title: 'Accessories',
      cueTitle: ['Decor', 'Edit'],
      summary: 'Decor accessories and objects selected to finish shelves, consoles, coffee tables and styled corners.',
      filters: [
        { label: 'Decor Objects', words: ['decor', 'object', 'sculpture'] },
        { label: 'Vases', words: ['vase', 'jar', 'pot'] },
        { label: 'Tabletop', words: ['tabletop', 'tray', 'bowl'] }
      ]
    },
    'beds-1': {
      eyebrow: 'Bedroom edit',
      title: 'Beds',
      cueTitle: ['Bed', 'Edit'],
      summary: 'Beds selected for refined bedrooms, guest rooms and comfortable modern homes.',
      filters: [
        { label: 'Upholstered', words: ['fabric', 'upholstered', 'velvet', 'boucle'] },
        { label: 'Storage Beds', words: ['storage', 'drawer', 'box'] },
        { label: 'Statement Beds', words: ['statement', 'premium', 'leather'] }
      ]
    },
    'study-table': {
      eyebrow: 'Study corners',
      title: 'Study Tables',
      cueTitle: ['Study Table', 'Edit'],
      summary: 'Study tables and focused work surfaces selected for bedrooms, home offices and compact work zones.',
      filters: [
        { label: 'Study Tables', words: ['study', 'desk', 'table'] },
        { label: 'Compact', words: ['compact', 'small', 'slim'] },
        { label: 'Storage', words: ['drawer', 'shelf', 'storage'] }
      ]
    },
    'coplanar-wardrobe': {
      eyebrow: 'Closet systems',
      title: 'Coplanar Wardrobes',
      cueTitle: ['Wardrobe', 'Edit'],
      summary: 'Coplanar wardrobes and closet systems selected for refined bedroom storage and seamless interiors.',
      filters: [
        { label: 'Coplanar', words: ['coplanar', 'sliding'] },
        { label: 'Wardrobes', words: ['wardrobe', 'closet'] },
        { label: 'Bedroom Storage', words: ['storage', 'bedroom', 'door'] }
      ]
    },
    lights: {
      eyebrow: 'Decor lighting',
      title: 'Lighting',
      cueTitle: ['Lighting', 'Edit'],
      summary: 'Floor lamps, pendant lights, table lamps and chandeliers selected to bring atmosphere, warmth and sculptural detail into finished rooms.',
      filters: [
        { label: 'Floor Lamps', words: ['floor lamp', 'floor', 'standing'] },
        { label: 'Pendant & Chandeliers', words: ['pendant', 'chandelier', 'hanging', 'ceiling'] },
        { label: 'Table Lamps', words: ['table lamp', 'desk lamp', 'aurea table', 'halo table'] }
      ]
    }
  };

  var FALLBACK = {
    eyebrow: 'Curated collection',
    title: '',
    cueTitle: ['The Avian', 'Edit'],
    summary: 'A design-led selection of luxury furniture curated for modern homes, villas, apartments and interior projects.',
    filters: [
      { label: 'Design Led', words: ['design', 'statement', 'premium'] },
      { label: 'Comfort First', words: ['comfort', 'soft', 'lounge'] },
      { label: 'Material Focus', words: ['wood', 'leather', 'fabric', 'marble', 'metal'] }
    ]
  };

  function handle() {
    var parts = location.pathname.split('/').filter(Boolean);
    var collectionIndex = parts.indexOf('collections');
    return collectionIndex > -1 ? (parts[collectionIndex + 1] || '') : (parts.pop() || '');
  }

  function nativeTitle() {
    var h1 = document.querySelector('.collection-title, .collection-hero__title, h1');
    return (h1 ? h1.textContent : '').replace(/^Collection:\s*/i, '').trim();
  }

  function cfg() {
    var data = COLLECTIONS[handle()] || FALLBACK;
    return Object.assign({}, data, { title: data.title || nativeTitle() || 'Collection' });
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function productGrid() {
    return document.querySelector('#ProductGridContainer .product-grid, #product-grid');
  }

  function productItems() {
    return Array.from(document.querySelectorAll('#ProductGridContainer .product-grid .grid__item, #product-grid > .grid__item'));
  }

  function itemText(item) {
    return ((item.textContent || '') + ' ' + Array.from(item.querySelectorAll('a')).map(function (a) {
      return [a.href, a.getAttribute('aria-label'), a.textContent].join(' ');
    }).join(' ')).toLowerCase().replace(/[-_]+/g, ' ');
  }

  function matchesFilter(item, filter) {
    if (!filter) return true;
    var text = itemText(item);
    return filter.words.some(function (word) { return text.indexOf(word.toLowerCase()) !== -1; });
  }

  function hasLoadedMatch(filter) {
    return Boolean(filter && productItems().some(function (item) {
      return matchesFilter(item, filter);
    }));
  }

  function ensureOriginalIndexes() {
    productItems().forEach(function (item, index) {
      if (!item.dataset.avianOriginalIndex) item.dataset.avianOriginalIndex = String(index + 1);
    });
    originalIndexSet = true;
  }

  function activeFilter() {
    var data = cfg();
    return data.filters.find(function (filter) { return filter.label === state.cue; }) || null;
  }

  function applyGuidedOrder() {
    var grid = productGrid();
    if (!grid) return;
    ensureOriginalIndexes();
    var filter = activeFilter();
    var items = productItems();
    items.forEach(function (item) {
      var matched = matchesFilter(item, filter);
      item.classList.toggle('avian-guided-match', Boolean(filter && matched));
      item.classList.toggle('avian-guided-rest', Boolean(filter && !matched));
    });
    items.sort(function (a, b) {
      var am = matchesFilter(a, filter);
      var bm = matchesFilter(b, filter);
      if (am !== bm) return am ? -1 : 1;
      return Number(a.dataset.avianOriginalIndex || 0) - Number(b.dataset.avianOriginalIndex || 0);
    }).forEach(function (item) {
      grid.appendChild(item);
    });
    updateGuidedCopy();
  }

  function countText() {
    var total = Number(window.__avianCollectionProductTotal || 0);
    if (total > 0) return String(total);
    var counter = document.getElementById('ProductCountDesktop') || document.getElementById('ProductCount');
    var text = counter ? counter.textContent.replace(/,/g, '') : '';
    var numbers = text.match(/\d+/g);
    if (numbers && numbers.length) return numbers[numbers.length - 1];
    var loaded = productItems().length;
    return loaded ? String(loaded) : '0';
  }

  function sortSelect() {
    return document.querySelector('select[name="sort_by"], #SortBy, #SortBy-mobile');
  }

  function sortOptions() {
    var select = sortSelect();
    if (!select) return [];
    return Array.from(select.options).filter(function (option) {
      return option.value;
    }).map(function (option) {
      return {
        value: option.value,
        label: option.textContent.replace(/\s+/g, ' ').trim(),
        selected: option.selected
      };
    });
  }

  function ensureFonts() {
    if (document.querySelector('link[data-avian-approved-fonts]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500&family=Jost:wght@300;400;500;600;700&display=swap';
    link.dataset.avianApprovedFonts = 'true';
    document.head.appendChild(link);
  }

  function ensureStyles() {
    if (document.getElementById('avianApprovedCollectionStyles20260729')) return;
    var style = document.createElement('style');
    style.id = 'avianApprovedCollectionStyles20260729';
    style.textContent = [
      'body.collection{--avian-a-ink:#171514;--avian-a-brown:#403126;--avian-a-muted:#776d63;--avian-a-line:#e1d6c6;--avian-a-ivory:#fbf8f1;--avian-a-paper:#fffdf8;--avian-a-gold:#aa7d46;}',
      '.avian-desktop-collection,.avian-mobile-cue,.avian-filter-drawer,.avian-filter-backdrop{font-family:Jost,Poppins,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;box-sizing:border-box;}',
      '.avian-desktop-collection *,.avian-mobile-cue *,.avian-filter-drawer *{box-sizing:border-box;}',
      '.apg-guided-filter-panel,.apg-guided-active-summary{display:none!important;}',
      '.avian-guided-rest,.avian-guided-match{opacity:1!important;transform:none!important;}',
      '.avian-guided-match{order:-1!important;}',
      '.avian-guided-rest{order:0!important;}',
      '@media screen and (min-width:750px){',
      'body.collection.avian-approved-ready{background:var(--avian-a-ivory);}',
      'body.collection.avian-approved-ready .collection-hero,body.collection.avian-approved-mobile .collection-hero{display:none!important;}',
      'body.collection.avian-approved-ready #main-collection-filters{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;}',
      '.avian-mobile-cue{display:none!important;}',
      '.avian-desktop-collection{display:block;max-width:1240px;margin:0 auto;padding:54px 24px 26px;color:var(--avian-a-ink);}',
      '.avian-desktop-collection__head{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:end;gap:34px;padding-bottom:30px;border-bottom:1px solid var(--avian-a-line);}',
      '.avian-desktop-collection__eyebrow{margin:0 0 18px;color:var(--avian-a-gold);font-size:12px;font-weight:700;letter-spacing:.28em;text-transform:uppercase;}',
      '.avian-desktop-collection__title{margin:0;color:var(--avian-a-ink);font-family:"Cormorant Garamond",Georgia,serif;font-size:clamp(68px,7vw,116px);font-weight:400;line-height:.9;letter-spacing:0;}',
      '.avian-desktop-collection__summary{max-width:620px;margin:26px 0 0;color:var(--avian-a-muted);font-size:15px;line-height:1.8;letter-spacing:.03em;font-weight:300;}',
      '.avian-desktop-collection__tools{display:flex;align-items:flex-end;justify-content:flex-end;gap:28px;white-space:nowrap;}',
      '.avian-tool,.avian-count{border:0;border-bottom:1px solid rgba(170,125,70,.42);background:transparent;color:#3b3028;min-width:0;padding:0 0 12px;font:700 12px/1 Jost,Poppins,sans-serif;letter-spacing:.22em;text-transform:uppercase;}',
      '.avian-count{cursor:default;}',
      '.avian-tool{cursor:pointer;}',
      '.avian-tool:hover,.avian-tool.is-active{color:var(--avian-a-gold);border-bottom-color:var(--avian-a-gold);}',
      '.avian-sort-wrap{position:relative;}',
      '.avian-sort-menu{position:absolute;right:0;top:calc(100% + 12px);z-index:30;display:none;width:230px;padding:8px;background:#fffaf2;border:1px solid var(--avian-a-line);box-shadow:0 18px 48px rgba(64,49,38,.12);}',
      '.avian-sort-menu.is-open{display:grid;gap:4px;}',
      '.avian-sort-option{width:100%;padding:12px 11px;border:0;background:transparent;color:var(--avian-a-brown);cursor:pointer;text-align:left;font:500 11px/1.2 Jost,Poppins,sans-serif;letter-spacing:.12em;text-transform:uppercase;}',
      '.avian-sort-option:hover,.avian-sort-option.is-selected{background:#f4ede2;}',
      '.avian-filter-backdrop{position:fixed;inset:0;z-index:9996;display:none;background:rgba(32,35,44,.24);backdrop-filter:blur(3px);}',
      '.avian-filter-backdrop.is-open{display:block;}',
      '.avian-filter-drawer{position:fixed;top:0;right:0;z-index:9997;width:min(420px,calc(100vw - 30px));height:100vh;background:#fbf8f1;border-left:1px solid var(--avian-a-line);box-shadow:-22px 0 62px rgba(64,49,38,.12);transform:translateX(104%);transition:transform .26s ease;display:grid;grid-template-rows:auto minmax(0,1fr) auto;color:var(--avian-a-ink);}',
      '.avian-filter-drawer.is-open{transform:translateX(0)!important;}',
      '.avian-filter-head{display:flex;align-items:flex-start;justify-content:space-between;gap:18px;padding:30px 30px 22px;border-bottom:1px solid var(--avian-a-line);}',
      '.avian-filter-eyebrow{margin:0 0 7px;color:var(--avian-a-gold);font-size:10.5px;font-weight:700;letter-spacing:.2em;text-transform:uppercase;}',
      '.avian-filter-title{margin:0;font-family:"Cormorant Garamond",Georgia,serif;font-size:40px;font-weight:400;line-height:.9;}',
      '.avian-filter-close{width:34px;height:34px;border:1px solid rgba(170,125,70,.32);background:transparent;color:var(--avian-a-brown);cursor:pointer;font-size:18px;}',
      '.avian-filter-body{overflow:auto;padding:26px 30px;}',
      '.avian-filter-note{margin:0 0 22px;color:var(--avian-a-muted);font-size:13px;line-height:1.6;font-weight:300;}',
      '.avian-filter-options{display:grid;gap:10px;}',
      '.avian-filter-chip{width:100%;min-height:48px;border:1px solid var(--avian-a-line);background:#fffaf2;color:var(--avian-a-brown);cursor:pointer;text-align:left;padding:14px 15px;font:600 12px/1 Jost,Poppins,sans-serif;letter-spacing:.13em;text-transform:uppercase;transition:background .2s ease,color .2s ease,border-color .2s ease;}',
      '.avian-filter-chip.is-active,.avian-filter-chip:hover{background:var(--avian-a-brown);border-color:var(--avian-a-brown);color:#fff8ee;}',
      '.avian-filter-actions{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:18px 30px 26px;border-top:1px solid var(--avian-a-line);}',
      '.avian-filter-action{min-height:44px;border:1px solid var(--avian-a-brown);cursor:pointer;font:700 11px/1 Jost,Poppins,sans-serif;letter-spacing:.14em;text-transform:uppercase;}',
      '.avian-filter-clear{background:transparent;color:var(--avian-a-brown);}',
      '.avian-filter-view{background:var(--avian-a-brown);color:#fff8ee;}',
      '.avian-active-cue{display:none;max-width:1240px;margin:18px auto 0;color:#6d6258;font-size:11px;letter-spacing:.1em;line-height:1.2;text-transform:uppercase;}',
      '.avian-active-cue.is-visible{display:flex;align-items:center;gap:8px;flex-wrap:wrap;}',
      '.avian-active-cue strong{color:var(--avian-a-gold);letter-spacing:.16em;}',
      '.avian-active-cue button{border:0;border-bottom:1px solid rgba(163,122,72,.5);background:transparent;color:#8f6f46;cursor:pointer;font:800 10px/1 Jost,Poppins,sans-serif;letter-spacing:.16em;text-transform:uppercase;}',
      '}',
      '@media screen and (min-width:750px) and (max-width:989px){',
      '.avian-desktop-collection{padding:36px 18px 20px;}',
      '.avian-desktop-collection__head{grid-template-columns:1fr;gap:20px;padding-bottom:22px;}',
      '.avian-desktop-collection__title{font-size:clamp(44px,8vw,62px);}',
      '.avian-desktop-collection__summary{font-size:13px;line-height:1.55;}',
      '.avian-desktop-collection__tools{justify-content:flex-start;}',
      '.avian-sort-menu{left:0;right:auto;}',
      '}',
      '@media screen and (max-width:749px){',
      '.avian-desktop-collection,.avian-filter-drawer,.avian-filter-backdrop{display:none!important;}',
      'body.collection.avian-approved-mobile #main-collection-filters{display:none!important;}',
      '.avian-mobile-cue{display:block;margin:18px 28px 14px;padding-bottom:12px;border-bottom:1px solid rgba(222,211,195,.85);color:var(--avian-a-ink);}',
      '.avian-mobile-cue__line{display:flex;align-items:center;justify-content:space-between;gap:14px;margin-bottom:10px;}',
      '.avian-mobile-cue__title{display:inline-flex;align-items:baseline;gap:5px;color:var(--avian-a-brown);line-height:1;white-space:nowrap;}',
      '.avian-mobile-cue__title span{font-size:9.5px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;}',
      '.avian-mobile-cue__title em{font-family:"Cormorant Garamond",Georgia,serif;font-size:17px;font-style:italic;font-weight:400;letter-spacing:.01em;}',
      '.avian-mobile-cue__count{color:var(--avian-a-muted);font-size:10px;line-height:1;letter-spacing:.08em;text-transform:uppercase;white-space:nowrap;}',
      '.avian-mobile-cue__chips{display:flex;gap:14px;overflow-x:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch;padding:3px 0 2px;}',
      '.avian-mobile-cue__chips::-webkit-scrollbar{display:none;}',
      '.avian-mobile-cue__chip{flex:0 0 auto;border:0;border-bottom:1px solid rgba(167,122,69,.35);background:transparent;color:var(--avian-a-muted);padding:0 0 6px;cursor:pointer;font-size:10.5px;line-height:1;font-weight:500;letter-spacing:.09em;text-transform:uppercase;}',
      '.avian-mobile-cue__chip.is-active{color:var(--avian-a-brown);border-color:var(--avian-a-brown);font-weight:600;}',
      '.avian-mobile-cue__copy{margin:9px 0 0;color:var(--avian-a-muted);font-size:10px;line-height:1.35;font-weight:300;}',
      '.avian-mobile-cue__copy:before{content:"";display:inline-block;width:4px;height:4px;margin:0 7px 1px 0;border-radius:50%;background:var(--avian-a-gold);}',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function ensureDesktopHeader() {
    if (document.querySelector('.avian-desktop-collection')) return;
    var target = document.getElementById('ProductGridContainer');
    if (!target) return;
    var data = cfg();
    var section = document.createElement('section');
    section.className = 'avian-desktop-collection';
    section.setAttribute('aria-label', 'Collection introduction');
    section.innerHTML =
      '<div class="avian-desktop-collection__head">' +
        '<div>' +
          '<p class="avian-desktop-collection__eyebrow">' + escapeHTML(data.eyebrow) + '</p>' +
          '<h1 class="avian-desktop-collection__title">' + escapeHTML(data.title) + '</h1>' +
          '<p class="avian-desktop-collection__summary">' + escapeHTML(data.summary) + '</p>' +
        '</div>' +
        '<div class="avian-desktop-collection__tools" aria-label="Collection tools">' +
          '<button class="avian-count" type="button" disabled><span id="avianCollectionCount">' + escapeHTML(countText()) + '</span> pieces</button>' +
          '<div class="avian-sort-wrap">' +
            '<button class="avian-tool" id="avianSortButton" type="button" aria-expanded="false">Sort</button>' +
            '<div class="avian-sort-menu" id="avianSortMenu"></div>' +
          '</div>' +
          '<button class="avian-tool" id="avianFilterButton" type="button" aria-expanded="false">Filter</button>' +
        '</div>' +
      '</div>' +
      '<div class="avian-active-cue" id="avianActiveCue" aria-live="polite"></div>';
    target.parentNode.insertBefore(section, target);
  }

  function ensureDrawer() {
    if (document.querySelector('.avian-filter-drawer')) return;
    var data = cfg();
    var backdrop = document.createElement('div');
    backdrop.className = 'avian-filter-backdrop';
    backdrop.id = 'avianFilterBackdrop';
    var drawer = document.createElement('aside');
    drawer.className = 'avian-filter-drawer';
    drawer.id = 'avianFilterDrawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="avian-filter-head">' +
        '<div><p class="avian-filter-eyebrow">Refine collection</p><h2 class="avian-filter-title">Style cues</h2></div>' +
        '<button class="avian-filter-close" id="avianFilterClose" type="button" aria-label="Close filters">×</button>' +
      '</div>' +
      '<div class="avian-filter-body">' +
        '<p class="avian-filter-note">Choose one cue to bring matching pieces forward. Nothing gets hidden.</p>' +
        '<div class="avian-filter-options">' +
          data.filters.map(function (filter) {
            return '<button class="avian-filter-chip" type="button" data-avian-filter="' + escapeHTML(filter.label) + '">' + escapeHTML(filter.label) + '</button>';
          }).join('') +
        '</div>' +
      '</div>' +
      '<div class="avian-filter-actions">' +
        '<button class="avian-filter-action avian-filter-clear" id="avianFilterClear" type="button">Clear</button>' +
        '<button class="avian-filter-action avian-filter-view" id="avianFilterView" type="button">View pieces</button>' +
      '</div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);
    var viewButton = drawer.querySelector('#avianFilterView');
    if (viewButton) {
      viewButton.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        var button = document.getElementById('avianFilterButton');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }
  }

  function renderSortMenu() {
    var menu = document.getElementById('avianSortMenu');
    if (!menu) return;
    var options = sortOptions();
    if (!options.length) {
      menu.innerHTML = '<button class="avian-sort-option is-selected" type="button">Featured</button>';
      return;
    }
    menu.innerHTML = options.map(function (option) {
      return '<button class="avian-sort-option' + (option.selected ? ' is-selected' : '') + '" type="button" data-sort-value="' + escapeHTML(option.value) + '">' + escapeHTML(option.label) + '</button>';
    }).join('');
  }

  function setSort(value) {
    var select = sortSelect();
    if (!select || !value) return;
    select.value = value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function () {
      ensureOriginalIndexes();
      applyGuidedOrder();
      updateCount();
      bindInfiniteScroll(true);
    }, 900);
  }

  function updateCount() {
    var count = document.getElementById('avianCollectionCount');
    if (count) count.textContent = countText();
    var mobileCount = document.querySelector('.avian-mobile-cue__count');
    if (mobileCount) mobileCount.textContent = countText() + ' pieces';
    renderSortMenu();
  }

  function updateGuidedCopy() {
    var copy = document.querySelector('.avian-mobile-cue__copy');
    if (copy) copy.textContent = state.cue ? state.cue + ' pieces are shown first. Nothing is hidden.' : 'Tap a style to bring matching pieces forward.';
    var activeCue = document.getElementById('avianActiveCue');
    if (activeCue) {
      activeCue.classList.toggle('is-visible', Boolean(state.cue));
      activeCue.innerHTML = state.cue ? '<strong>Showing first</strong><span>' + escapeHTML(state.cue) + '</span><button type="button" id="avianClearActiveCue">Clear</button>' : '';
    }
    document.querySelectorAll('[data-avian-filter], .avian-mobile-cue__chip').forEach(function (button) {
      var value = button.dataset.avianFilter || '';
      button.classList.toggle('is-active', value === state.cue);
    });
    var filterButton = document.getElementById('avianFilterButton');
    if (filterButton) filterButton.classList.toggle('is-active', Boolean(state.cue));
  }

  function setCue(value) {
    state.cue = state.cue === value ? '' : value;
    applyGuidedOrder();
    var filter = activeFilter();
    if (filter && !hasLoadedMatch(filter)) loadAheadForFilter(filter, 0);
  }

  function ensureMobileCue() {
    if (document.querySelector('.avian-mobile-cue')) return;
    var target = document.getElementById('ProductGridContainer');
    if (!target) return;
    var data = cfg();
    var cue = document.createElement('section');
    cue.className = 'avian-mobile-cue';
    cue.setAttribute('aria-label', 'Collection style cues');
    cue.innerHTML =
      '<div class="avian-mobile-cue__line">' +
        '<strong class="avian-mobile-cue__title"><span>' + escapeHTML(data.cueTitle[0]) + '</span><em>' + escapeHTML(data.cueTitle[1]) + '</em></strong>' +
        '<span class="avian-mobile-cue__count">' + escapeHTML(countText()) + ' pieces</span>' +
      '</div>' +
      '<div class="avian-mobile-cue__chips">' +
        '<button class="avian-mobile-cue__chip is-active" type="button" data-avian-filter="">All</button>' +
        data.filters.map(function (filter) {
          return '<button class="avian-mobile-cue__chip" type="button" data-avian-filter="' + escapeHTML(filter.label) + '">' + escapeHTML(filter.label) + '</button>';
        }).join('') +
      '</div>' +
      '<p class="avian-mobile-cue__copy">Tap a style to bring matching pieces forward.</p>';
    target.parentNode.insertBefore(cue, target);
  }

  function openDrawer() {
    var drawer = document.getElementById('avianFilterDrawer');
    var backdrop = document.getElementById('avianFilterBackdrop');
    var button = document.getElementById('avianFilterButton');
    if (!drawer || !backdrop) return;
    drawer.classList.add('is-open');
    drawer.style.transform = 'translateX(0)';
    backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (button) button.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    var drawer = document.getElementById('avianFilterDrawer');
    var backdrop = document.getElementById('avianFilterBackdrop');
    var button = document.getElementById('avianFilterButton');
    if (!drawer || !backdrop) return;
    drawer.classList.remove('is-open');
    drawer.style.transform = 'translateX(104%)';
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (button) button.setAttribute('aria-expanded', 'false');
  }

  function pageFromUrl(url) {
    try {
      var parsed = new URL(url, location.origin);
      return parseInt(parsed.searchParams.get('page') || '1', 10) || 1;
    } catch (error) {
      return 1;
    }
  }

  function maxPage() {
    var max = pageFromUrl(location.href);
    document.querySelectorAll('.pagination-wrapper a[href*="page="]').forEach(function (link) {
      max = Math.max(max, pageFromUrl(link.href));
    });
    return max;
  }

  function nextUrl() {
    if (!scrollState.nextPage) scrollState.nextPage = pageFromUrl(location.href) + 1;
    if (scrollState.nextPage > maxPage()) return '';
    var url = new URL(location.href);
    url.searchParams.set('page', String(scrollState.nextPage));
    return url.href;
  }

  function appendNextPagePromise() {
    var grid = document.getElementById('product-grid') || productGrid();
    var pager = document.querySelector('#ProductGridContainer .pagination-wrapper, .pagination-wrapper');
    var url = nextUrl();
    if (!grid || !pager || !url || scrollState.busy) return Promise.resolve(false);
    scrollState.busy = true;
    pager.style.opacity = '.42';
    return fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#product-grid');
        var newItems = newGrid ? Array.from(newGrid.children) : [];
        newItems.forEach(function (item) { grid.appendChild(document.importNode(item, true)); });
        scrollState.nextPage += 1;
        pager.style.opacity = '1';
        if (scrollState.nextPage > maxPage()) {
          pager.remove();
          if (scrollState.observer) scrollState.observer.disconnect();
        }
        originalIndexSet = false;
        ensureOriginalIndexes();
        applyGuidedOrder();
        updateCount();
        saveListingState();
        return newItems.length > 0;
      })
      .catch(function () {
        if (scrollState.observer) scrollState.observer.disconnect();
        return false;
      })
      .finally(function () {
        scrollState.busy = false;
      });
  }

  function appendNextPage() {
    appendNextPagePromise();
  }

  function loadAheadForFilter(filter, attempt) {
    if (!filter || hasLoadedMatch(filter) || attempt >= 4) return;
    appendNextPagePromise().then(function (added) {
      if (!added || hasLoadedMatch(filter)) return;
      loadAheadForFilter(filter, attempt + 1);
    });
  }

  function bindInfiniteScroll(reset) {
    var pager = document.querySelector('#ProductGridContainer .pagination-wrapper, .pagination-wrapper');
    if (!pager || !('IntersectionObserver' in window)) return;
    if (scrollState.observer) scrollState.observer.disconnect();
    if (reset || !scrollState.nextPage) scrollState.nextPage = pageFromUrl(location.href) + 1;
    scrollState.observer = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) appendNextPage();
    }, { rootMargin: '650px 0px' });
    scrollState.observer.observe(pager);
  }

  function bindEvents() {
    if (document.body.dataset.avianApprovedEventsBound === 'true') return;
    document.body.dataset.avianApprovedEventsBound = 'true';
    document.addEventListener('click', function (event) {
      var target = event.target;
      var sortButton = target.closest('#avianSortButton');
      var sortOption = target.closest('.avian-sort-option[data-sort-value]');
      var sortWrap = target.closest('.avian-sort-wrap');
      var filterButton = target.closest('#avianFilterButton');
      var drawerClose = target.closest('#avianFilterClose, #avianFilterBackdrop, #avianFilterView');
      var clear = target.closest('#avianFilterClear, #avianClearActiveCue');
      var chip = target.closest('[data-avian-filter]');
      var sortMenu = document.getElementById('avianSortMenu');
      var productLink = target.closest('#ProductGridContainer a[href*="/products/"], #product-grid a[href*="/products/"]');
      if (productLink) saveListingState();
      if (sortButton) {
        var isOpen = sortMenu && sortMenu.classList.toggle('is-open');
        sortButton.classList.toggle('is-active', Boolean(isOpen));
        sortButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        return;
      }
      if (sortOption) {
        setSort(sortOption.dataset.sortValue);
        if (sortMenu) sortMenu.classList.remove('is-open');
        var button = document.getElementById('avianSortButton');
        if (button) button.classList.remove('is-active');
        return;
      }
      if (!sortWrap && sortMenu) {
        sortMenu.classList.remove('is-open');
        var sort = document.getElementById('avianSortButton');
        if (sort) sort.classList.remove('is-active');
      }
      if (filterButton) {
        openDrawer();
        return;
      }
      if (drawerClose) {
        closeDrawer();
        return;
      }
      if (clear) {
        state.cue = '';
        applyGuidedOrder();
        return;
      }
      if (chip) {
        setCue(chip.dataset.avianFilter || '');
        if (chip.closest('.avian-filter-drawer')) {
          setTimeout(closeDrawer, 140);
        }
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });
    window.addEventListener('pagehide', saveListingState);
    document.addEventListener('change', function () {
      setTimeout(function () {
        originalIndexSet = false;
        ensureOriginalIndexes();
        applyGuidedOrder();
        updateCount();
        bindInfiniteScroll(true);
      }, 900);
    });
  }

  function init() {
    if (!document.getElementById('ProductGridContainer') || !productGrid()) return;
    ensureFonts();
    ensureStyles();
    var restoredListing = restoreListingState();
    ensureOriginalIndexes();
    if (mqDesktop.matches) {
      document.body.classList.add('avian-approved-ready');
      document.body.classList.remove('avian-approved-mobile');
      ensureDesktopHeader();
      ensureDrawer();
      renderSortMenu();
    } else {
      document.body.classList.add('avian-approved-mobile');
      document.body.classList.remove('avian-approved-ready');
      ensureMobileCue();
    }
    bindEvents();
    applyGuidedOrder();
    bindInfiniteScroll(!restoredListing);
    updateCount();
    restoreScrollPosition();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', init);
})();

/* Avian collection drawer runtime patch - 2026-08-02 */
(function () {
  if (!document.body.classList.contains('collection')) return;

  function drawer() {
    return document.getElementById('avianFilterDrawer');
  }

  function forceOpen() {
    var panel = drawer();
    if (panel && panel.classList.contains('is-open')) {
      panel.style.transform = 'translateX(0)';
    }
  }

  function forceClosed() {
    var panel = drawer();
    if (panel && !panel.classList.contains('is-open')) {
      panel.style.transform = 'translateX(104%)';
    }
  }

  function addRule() {
    if (document.getElementById('avianDrawerRuntimePatch')) return;
    var style = document.createElement('style');
    style.id = 'avianDrawerRuntimePatch';
    style.textContent = '.avian-filter-drawer.is-open{transform:translateX(0)!important;}';
    document.head.appendChild(style);
  }

  function watchDrawer() {
    var panel = drawer();
    if (!panel || panel.__avianDrawerRuntimePatch) return;
    panel.__avianDrawerRuntimePatch = true;
    new MutationObserver(function () {
      if (panel.classList.contains('is-open')) forceOpen();
      else forceClosed();
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
  }

  addRule();
  watchDrawer();

  document.addEventListener('click', function (event) {
    if (event.target.closest('#avianFilterButton')) {
      setTimeout(function () {
        watchDrawer();
        forceOpen();
      }, 0);
    }
    if (event.target.closest('#avianFilterClose,#avianFilterBackdrop,#avianFilterView')) {
      setTimeout(forceClosed, 0);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setTimeout(forceClosed, 0);
    }
  }, true);
})();
